  import React from "react";
import moment from 'moment';
import { Link,Redirect } from "react-router-dom";
import {getData,downloadExcelReports} from '../../services/index';
import { Collapse,Popconfirm, Radio,Checkbox,label,Input,Popover, Button ,Tooltip,TimePicker,message,Select,Modal,DatePicker   } from 'antd';

import Pagination from "react-js-pagination";
import FilterTable from "../../component/student_fees_change_table";

const { TextArea } = Input;
const { Panel } = Collapse;

const buttonWidth = 70;

function callback(key) {
  console.log(key);
}

function onChange(time, timeString) {
  console.log(time, timeString);
}

function onChangechecked(checkedValues) {
  console.log('checked = ', checkedValues);
}
const { Option } = Select;

const { RangePicker } = DatePicker;

class Index extends React.Component {
	static contextTypes = {
        router: () => null
    };
	constructor(props) {
		super(props);
		this.state = {
			total_count: 0,
			school_list: [],
			new_date:["",""],
		}
		this.DateChange = this.DateChange.bind(this);
		this.handleSizeChange = this.handleSizeChange.bind(this);
	}
	
	componentWillMount() {
		document.querySelector(".loader-wrapper").style = "display: none";
		setTimeout(() => {
			document.querySelector(".loader-wrapper").style = "display: none";
		}, 500);
		if(!localStorage.getItem('schoolData')) {
			localStorage.setItem("schoolData",'');
			localStorage.clear();
			window.location.href = '/login';
		}else{
			var date = new Date().toLocaleString("en-US", {timeZone: "Asia/Kolkata"});
			const new_acad = (new Date().getFullYear())+'-'+ (new Date().getFullYear()+1);
			
			var storedArray = JSON.parse(localStorage.getItem("schoolData"))
			var permission = storedArray['data'][0]['permission'];
			var user_type = storedArray['data'][0]['type'];
			var today = new Date();
			var month = today.getMonth() + 1
			if(month < 10){
				month = '0'+ month;
			}else{
				month = month;
			}
			console.log('m:',month);
			setTimeout(() => {
				this.setState({ 
					user_id : storedArray['data'][0]['user_id'],
					school_id : storedArray['data'][0]['school_id'],
					permission : permission,
					user_type : user_type,
					academic_year : new_acad,
					month : month,
				});
			}, 50);
			const params = new Proxy(new URLSearchParams(window.location.search), {
				get: (searchParams, prop) => searchParams.get(prop),
			});
			if(params.new_date && params.new_date != null){
				var new_date = params.new_date;
				this.setState({new_date: new_date});
			}
			
		}
		var user_id = storedArray['data'][0]['user_id'];
		var school_id = storedArray['data'][0]['school_id'];
		var type = storedArray['data'][0]['type'];
		var app = {user_id : user_id,school_id:school_id,type:type}
		getData('auth/get_login_token',app).then((result) => {
			let responseJson = result;
			if(responseJson.data){
				if(result['status'] == 200){
					var aToken= result['data'];
					localStorage.setItem("aToken",aToken);
					var main_link = 'https://erp.kidzonia.co.in/panel/admin';
					var dayplan_link = 'https://erp.kidzonia.co.in/panel/dayplan';
					this.setState({
						main_link: main_link,
						dayplan_link: dayplan_link,
						aToken:aToken
					});
				}
				else{
					var aToken='null';
					localStorage.setItem("aToken",aToken);
					var main_link = 'https://erp.kidzonia.co.in/panel/admin';
					var dayplan_link = 'https://erp.kidzonia.co.in/panel/dayplan';
					this.setState({
						main_link: main_link,
						dayplan_link: dayplan_link,
						aToken:aToken
					});
				}
			}
		});
		
			
			
			setTimeout(() => {
				this.checkData();
			}, 300);
	}
	
	handleSubmit(e){
		setTimeout(() => {
			let params = '?new_date='+this.state.new_date;
			document.location.search = params;
			this.setState({ page: 1 });
			this.checkData();
		}, 50);
	} 
	
	checkData(){
  	    if(localStorage.getItem('schoolData')){
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			this.setState({ user_id : storedArray['data'][0]['user_id'] });
			var user_id = storedArray['data'][0]['user_id'];
			var school_id = storedArray['data'][0]['school_id'];
			const params = new Proxy(new URLSearchParams(window.location.search), {
				get: (searchParams, prop) => searchParams.get(prop),
			});
			if(params.new_date && params.new_date != null){
				var new_date = params.new_date;
			}else{
				var new_date = this.state.new_date;
			}
			
			
			var app = {user_id : user_id,school_id:school_id,page:this.state.page,new_date:new_date,per_page: this.state.perPage}
			getData('report/fees_change_report',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							school_list: result['data'],
							total_count: result['total_school'],
							is_show: 1,
						});
					}else{
						this.setState({
							school_list: [],
							total_count: 0,
							is_show: 1,
						});
					}
				}
			});
	}
    }
	
	
	
	
	handleSizeChange = e => {
		this.setState({ [e.target.name]: e.target.value });
	};
	
	DateChange(date, dateString) {
	  this.setState({ new_date: dateString });
	}
  

	render()

	{
	const {aToken} = this.state;
	const { size } = this.state;
	
	
					
		return (
			<>
				
				
				<div class="row bred">
					<div class="col-md-12">
						<div class="card">
							<div class="card-body">
								<h4 class="page-title"> 
									<i class="mdi mdi-apple-keyboard-command title_icon"></i>Fees Change Report
									<div class="breadcrumb-wrapper">
										<ol class="breadcrumb">
											<li class="breadcrumb-item">
												<a href={`${process.env.PUBLIC_URL}/`} class="router-link-active" target="_self">
												<img src="https://erp.kidzonia.co.in/panel/assets/icons/home.png" className="home-img"/>
												</a>
											</li>
											<li class="breadcrumb-item"> Fees Change Report </li>
										</ol>
									</div>
								</h4>
							</div>
						</div>
					</div>
				</div>
				
				<div class="row hidden">
					<div class="col-md-12">
					<div class="card">
					<div class="card-body">
						
						<div class="row">
						
						<div class="col-md-3">
							<div class="form-group">
								<label  style={{paddingTop: '14px'}}><b>Date</b></label>
								<RangePicker className="date-range" onChange={this.DateChange.bind(this)} />
							</div>
						</div>
						<div class="col-md-2 pt-4">
							<div class="form-group pt-1">
								 <Button className="btn btn-primary mr-2 pt-10" style={{display: 'block'}} id="submit_btn" onClick={this.handleSubmit.bind(this)} >Apply</Button>
							</div>
						</div>
						
						</div>
						
					</div>
					</div>
					</div>
				</div>
				
				
                <div class="">
                  <div class="row">
                     <div class="col-lg-12 mb-3 form-group">
					 <div class="card">
						<div class="card-body">
						<div class="row">
						<div class="col-sm-2 col-12 text-left  enquiry-btn mt-10">
							<h4 class="header-title mt-5px">Total Child : {this.state.total_count}</h4>
						</div>
						<div class="col-sm-10 col-12 text-right  enquiry-btn mt-5px">
							
						</div>
						</div>
						
                        <div class="table-responsive new-table">
                            <div class="hidden-xs mt-15">
							  <FilterTable 
									data={this.state.school_list}
									page_name='enquiries'
								/>
							</div>
                        </div>
                        </div>
                        </div>
                     </div>
                  </div>
               </div>
			   </>
		) 
	} 
}
export default Index;
